import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { IDashboardOperationRequest, IDashboardOperationResponse, IKpiResponse } from 'src/app/modules/shared/models/operation.model';
import { environment } from 'src/environments/environment';
import { IOperationFilter } from 'src/app/modules/shared/models/policy.model';
import { LoggerService } from 'src/app/services/logger.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private _thereArePendingOperations = false;
  private _pendingOperations$ = new BehaviorSubject<void>(null);

  constructor(
    private readonly _http: HttpClient
  ) { }

  get isLocalEnv(): boolean {
    return environment.name === 'LOCAL_BE';
  }

  get thereArePendingOperations(): boolean {
    return this._thereArePendingOperations;
  }

  get pendingOperationSub(): Observable<void> {
    return this._pendingOperations$.asObservable();
  }

  notifyPendingOperations(val: boolean) {
    LoggerService.logInfo(this.constructor.name, 'notifyPendingOperation', {val});
    this._thereArePendingOperations = val;
  }

  triggerPendingOperations() {
    LoggerService.logInfo(this.constructor.name, 'triggerPendingOperations');
    this._pendingOperations$.next();
  }

  getMonthlyKpis(): Observable<IKpiResponse> {
    const url = environment.apiBaseUrl + environment.apiPaths.kpis;
    return this._http.get<IKpiResponse>(url);
  }

  getDashboardOperations(body: IDashboardOperationRequest): Observable<IDashboardOperationResponse> {
    const url = environment.apiBaseUrl + environment.apiPaths.dashboardOperations;
    if (this.isLocalEnv) {
      return this._http.get<IDashboardOperationResponse>('/mock/ongoingOperations');
    }
    return this._http.post<IDashboardOperationResponse>(url, body);
  }

  retrieveOpDomain(companyCode?: string): Observable<IOperationFilter[]> {
    let url = environment.apiBaseUrl + environment.apiPaths.operations;
    if (companyCode) {
      url = url + `?companyCode=${companyCode}`
    }
    return this._http.get<IOperationFilter[]>(url);
  }

  retrieveOpFilter(companyCode?: string): Observable<IOperationFilter[]> {
    let url = environment.apiBaseUrl + environment.apiPaths.cruscottoOperations;
    if (companyCode) {
      url = url + `?companyCode=${companyCode}`
    }
    return this._http.get<IOperationFilter[]>(url);
  }

}
